export default "__VITE_ASSET__C$UBFiDZ__"